var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"depressed":_vm.depressed,"dark":_vm.dark && !_vm.disabled,"block":_vm.block,"color":_vm.color,"dense":_vm.dense,"loading":_vm.loading,"to":_vm.to,"height":_vm.height,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }